import { Card, Row, Col, Typography, Image, Space } from 'antd';
import { ButtonCustomLink } from '../Button';


import LOGOTIPO_CONALEP from '../../assets/images/escudos/conalepEDOMEX.png';

const { Title, Paragraph } = Typography;

const WelcomePage = () => (
    <>
        <Row
            justify="center"
            align="middle"
            style={{
                minHeight: '70vh',
            }}
        >
            <Card
                style={{ width: '100%', maxWidth: '900px', border: 'none' }}
            >
                <Col>
                    <Row justify="center">
                        <Space align='middle' justify='center'>
                            <Col span={24}>
                                <Image
                                    src={LOGOTIPO_CONALEP}
                                    preview={false}
                                    alt='conalepedomex'
                                    width={"250px"}
                                    style={{ minWidth: "90px" }}
                                />
                            </Col>
                        </Space>
                    </Row>
                    {/* TÍTULO */}
                    <Row justify="center" style={{ marginBottom: 20, marginTop: 30 }}>
                        <Col>
                            <Title strong level={2} className='pompisSemiBold'>Bienvenid@ a Mi CONALEP</Title>
                        </Col>
                    </Row>

                    {/* TEXTO CENTRAL */}
                    <Row justify="center" style={{ marginBottom: 30 }}>
                        <Col xs={24} md={20} lg={18}>
                            <Paragraph style={{ textAlign: "justify", color: '#9ea6bb' }}>
                                <Title level={4} style={{ color: "gray" }}>
                                    Este espacio fue creado para la comunidad del CONALEP Estado de México,
                                    con el propósito de brindar un acceso fácil, rápido y seguro.
                                    Aquí podrás ingresar al Sistema de Cuadro de Mando y al Sistema de Egresados
                                    para consultar información y realizar tus gestiones de manera sencilla.
                                </Title>
                            </Paragraph>
                        </Col>

                    </Row>
                    <Row gutter={[16, 16]} justify="center"  >
                        <Col xs={24} md={8}>
                            <ButtonCustomLink
                                link="/inicio-sesion"
                                color="bronce"
                                size="large"
                                children="Servicios Administrativos"
                            />
                        </Col>
                        <Col xs={24} md={8}>
                            <ButtonCustomLink
                                link="/egresados"
                                color="bronce"
                                size="large"
                                children="Sistema de Egresados"
                            />
                        </Col>
                    </Row> 
                </Col>
            </Card>
        </Row>
    </>
);

export default WelcomePage;